import type { FunctionComponent } from "react";
import { useMemo } from "react";

import { useAggregatedDataV2 } from "~/hooks/useAggregatedDataV2.ts";
import userViewGuard from "~/hooks/useViewPermssionsCheck";
import { useAllProcessedInvoices } from "~/modules/billing/api/processedInvoice/processedInvoiceQueries.ts";
import ProcessedErroneousInvoicesIndexView from "~/modules/billing/components/ProcessedErroneousInvoicesIndexView";
import type {
	InvoiceIndexTableData,
} from "~/modules/billing/components/UnpaidInvoicesIndexView/unpaidInvoicesIndexTableTypes.ts";
import { PermissionNames } from "~/types/entityNames.ts";

const ProcessedErroneousInvoicesIndexPage: FunctionComponent = () => {
	const guard = userViewGuard([PermissionNames.CanManageInvoices, PermissionNames.CanViewInvoices]);
	if (guard) return guard;

	const { data, options } = useAggregatedDataV2({
		invoices: useAllProcessedInvoices(),
	});
	const { invoices } = data;

	const tableData: InvoiceIndexTableData[] = useMemo(() => {
		if (invoices) {
			return invoices
				.filter(invoice => invoice.hasImportErrors)
				.map((invoice) => {
					const transactionDate = invoice.sentAt || invoice.receivedAt
					return {
						...invoice,
						deliveryEndDate: new Date(invoice.deliveryEndDate),
						deliveryStartDate: new Date(invoice.deliveryStartDate),
						paidAt: invoice.paidAt ? new Date(invoice.paidAt) : null,
						transactionDate: transactionDate ? new Date(transactionDate) : null,
						updatedAt:invoice.updatedAt? new Date(invoice.updatedAt): null
					};
				});

		}
		return [];
	}, [invoices]);

	return <ProcessedErroneousInvoicesIndexView isLoading={options.isLoading}
									   tableData={tableData} />;
};

export default ProcessedErroneousInvoicesIndexPage;